import * as React from 'react';
import Lightbox from 'yet-another-react-lightbox';
import { Zoom } from 'yet-another-react-lightbox/plugins';
import 'yet-another-react-lightbox/styles.css';
import {useState, useEffect, useRef} from 'react';
import {signDocUrl_} from 'hooks/datahook/common';
import {isSignedImageUrl} from 'config/signedImageHosts';

const RotateIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 12a9 9 0 1 1-9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
        <path d="M21 21v-5h-5" />
    </svg>
);

const ZoomInIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35M11 8v6M8 11h6" />
    </svg>
);

const ZoomOutIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35M8 11h6" />
    </svg>
);

const CloseIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M18 6 6 18M6 6l12 12" />
    </svg>
);

const ImageViewer = (props) => {
    const {images, open, onClose} = props;
    const [photoIndex, setPhotoIndex] = useState(0);
    const [key, setKey] = useState(false);
    const [signedImages, setSignedImages] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);
    const [rotate, setRotate] = useState(0);
    const [zoom, setZoom] = useState(1);
    const zoomRef = useRef(null);

    const fetchNewImageUrl = async (url) => {
        try {
            const res = await signDocUrl_({url});
            return res.signedUrl;
        } catch (e) {
            console.error("fetchNewImageUrl error:", e);
            return "";
        }
    };

    // 处理图片 URL 签名
    useEffect(() => {
        const processImages = async () => {
            if (!open || !images || images.length === 0) {
                setSignedImages([]);
                setIsProcessing(false);
                return;
            }

            setIsProcessing(true);

            const processed = await Promise.all(
                images.map(async (url) => {
                    if (!isSignedImageUrl(url)) {
                        return url;
                    }

                    const newUrl = await fetchNewImageUrl(url);
                    return newUrl || url;
                })
            );

            setSignedImages(processed);
            setIsProcessing(false);
        };

        processImages();
    }, [open, images]);

    useEffect(() => {
        if (open) {
            setTimeout(() => setKey(key + 1));
            setRotate(0);
            setZoom(1);
        }
    }, [open]);

    return (
        open && !isProcessing && signedImages && signedImages.length > 0 && signedImages[photoIndex] && (
            <Lightbox
                key={key}
                open={open}
                close={onClose}
                slides={signedImages.map((src) => ({ src }))}
                index={photoIndex}
                onIndexChange={(index) => {
                    setPhotoIndex(index);
                    setRotate(0);
                    setZoom(1);
                }}
                // plugins={[Zoom]}
                zoom={{ ref: zoomRef }}
                carousel={{ imageProps: { style: { transform: `rotate(${rotate}deg) scale(${zoom})`, transition: 'transform 0.3s ease' } } }}
                toolbar={{
                    buttons: [
                        <button
                            key="rotate"
                            onClick={() => setRotate((r) => r + 90)}
                            title="Rotate"
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                color: 'white',
                                padding: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <RotateIcon />
                        </button>,
                        <button
                            key="zoom-out"
                            onClick={() => {
                                zoomRef.current?.zoomOut();
                                setZoom((z) => Math.max(0.5, z - 0.5));
                            }}
                            title="Zoom Out"
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                color: 'white',
                                padding: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <ZoomOutIcon />
                        </button>,
                        <button
                            key="zoom-in"
                            onClick={() => {
                                zoomRef.current?.zoomIn();
                                setZoom((z) => Math.min(5, z + 0.5));
                            }}
                            title="Zoom In"
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                color: 'white',
                                padding: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <ZoomInIcon />
                        </button>,
                        <button
                            key="close"
                            onClick={onClose}
                            title="Close"
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                color: 'white',
                                padding: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <CloseIcon />
                        </button>,
                    ],
                }}
            />
        )
    );
};

export default ImageViewer;